import { render, staticRenderFns } from "./MenuProfilButton.vue?vue&type=template&id=4a682758&scoped=true&"
import script from "./MenuProfilButton.vue?vue&type=script&lang=js&"
export * from "./MenuProfilButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a682758",
  null
  
)

export default component.exports